
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import { TranslateResult } from "vue-i18n";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiImport } from "@mdi/js";

@Component({
  computed: {
    mdiImport: () => mdiImport,
  },
  components: {
    SvgIcon,
  },
})
export default class ImportModal extends Vue {
  @Prop({ default: null })
  public title: TranslateResult;

  @Prop({ default: null })
  public type: string;

  @Prop({ default: false })
  public disabled: boolean;
  @Getter private envCompanyId: number | null;

  private csvFile: any = null;
  private importing: boolean = false;
  private relays: any[] = null;
  private boxes: any[] = [];
  // private searchBoxes: string = null;
  private boxesPagination: any = {
    // offset: 0,
    // limit: BOX_QUERY_LIMIT,
    loading: false,
  };
  private boxId: number = null;
  private searchRelays: string = null;
  private selectedRelay: any = null;
  private showDialog: boolean = false;
  private putKeysInRelay: boolean = false;
  private showConfirmationKeyDrop: boolean = false;
  @Watch("searchRelays")
  public handlerSearchRelays() {
    this.getRelays();
  }

  @Watch("selectedRelay")
  public handlerSelectedRelay() {
    this.putKeysInRelay = false;
    this.showConfirmationKeyDrop = false;
    this.boxId = null;
    if (this.selectedRelay) {
      // this.searchBoxes = "";
      // this.boxesPagination.offset = 0;
      // this.boxesPagination.limit = BOX_QUERY_LIMIT;
      this.showConfirmationKeyDrop = true;
      this.updateBoxes();
    }
  }

  @Watch("putKeysInRelay")
  public handlerSelectedBox() {
    if (!this.putKeysInRelay) {
        this.boxId = null;
    }
  }

  private openImportModal(): void {
    if (this.type === "keys") {
      this.getRelays();
    }
    this.showDialog = true;
  }

  get parsingType(): string {
      switch (this.type) {
          case "management":
          case "contacts":
              return "users";
          case "keys":
              return "keys";
          case "buildings":
              return "buildings";
          case "boxes":
              return "boxes";
          default:
              return null;
      }
  }

  get fileType(): string {
      switch (this.type) {
          case "keys":
              return "chooseFileWithXlsx";
          case "management":
          case "contacts":
          case "buildings":
          case "boxes":
              return "chooseFile";
          default:
              return null;
      }
  }

  get csvColumns(): string[] {
      switch (this.parsingType) {
          case "users":
              return [
                  "lastName",
                  "firstName",
                  "company",
                  "job",
                  "email",
                  "phone",
              ];
          case "keys":
              const columns: string[] = [
                "category",
                "name",
                "parent",
                "buildingName",
                "description",
                "tags",
                "managers",
              ];
              return columns;
          case "buildings":
             return  [
               "name",
               "address",
               "zipcode",
               "city",
               "registrationNumber",
             ];
          case "boxes":
             return  [
               "buildingName",
               "boxNumber",
               "boxName",
               "locationNb",
             ];
          default:
              return [];
      }
  }

  private isAvailable(location: any) {
      if (location?.keyId) { return false; } // not occupied if location was never used
      if (!location?.KeyLocation?.length) { return true; } // not occupied if location was never used
      return !location?.KeyLocation?.map((kL) => kL.endDate).includes(null); // is location currently used
  }

  private getRelays(): void {
    this.$store
      .dispatch("relays/getAll", {
        query: {
          search: this.searchRelays,
          type: "AGENCY",
          itemsPerPage: 10,
        },
      })
      .then(async (res) => {
        this.relays = res?.relays || [];
        await Promise.all(this.relays.map(async (relay) => {
          relay.totalAvailableReservedLocations = await this.$store.dispatch(
            "buildings/getBoxesExtended",
            {
              buildingId: relay.buildingId,
              allLocations: true,
            },
          ).then((data) => {
            const boxes = data.rows || [];
            let count = 0;
            boxes.forEach((box) => {
              box.Locations?.forEach((location) => {
                if (this.isAvailable(location)) {
                  count++;
                }
              });
              return count;
            });

          });
        }));
        if (this.relays?.length === 1) {
          this.selectedRelay = this.relays[0];
        }
      });
  }

  private updateBoxes(): Promise<any> {
    this.boxesPagination.loading = true;
    const buildingId: number = this.selectedRelay.buildingId;
    return this.$store.dispatch("buildings/getBoxesExtended", {
      buildingId,
      onlyNotConnected: true,
      // search: this.searchBoxes,
      // @TODO: Infinite scroll : https://www.codeply.com/p/BOwzZKhFvY
      // offset: this.boxesPagination.offset,
      // limit: this.boxesPagination.limit,
    }).then((res) => {
      this.boxes = res?.rows?.map((box) => ({
        text: this.$i18n.tc("box.number", box.number, {number: box.number})
          + (box.name ? ` (${box.name})` : ""),
        value: box.id,
      })) || [];
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.boxesPagination.loading = false;
    });
  }

  private parseFile() {
    if (this.csvFile) {
      this.importing = true;
      const formData = new FormData();
      formData.append("file", this.csvFile);
      this.$store
        .dispatch("files/parseImportFile", {
          type: this.parsingType,
          formData,
          companyId: this.envCompanyId,
        })
        .then((data) => {
            if (data && data.items?.length > 0) {
                this.$router.push({
                    name: `import-${this.parsingType}-preview`,
                    params: {
                        items: data.items,
                        importType: this.type,
                        companyId: String(this.envCompanyId),
                        relayId: String(this.selectedRelay?.id),
                        buildingId: String(this.selectedRelay?.buildingId),
                        boxId: String(this.boxId),
                        putKeysInRelay: this.putKeysInRelay ? "true" : "false",
                    },
                });
            } else {
                this.importing = false;
                this.$store.commit("alerts/displayError", {
                    msg: this.$i18n?.t("alerts.error.invalidOrEmptyFile"),
                });
            }
        })
        .catch((error) => {
            this.importing = false;
            this.$store.commit("alerts/displayHttpError", { error });
        });
    }
  }
}
